const primary = "#110E42";
const secondary = "#21A390";
const warning = "#FFC260";
const success = "#3CD4A0";
const info = "#9013FE";

export default {
    palette: {
        primary: {
            main: primary
        },
        secondary: {
            main: secondary
        },
        warning: {
            main: warning
        },
        success: {
            main: success
        },
        info: {
            main: info
        }
    },
    customShadows: {
        widget:
            "0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
        widgetDark:
            "0px 3px 18px 0px #4558A3B3, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
        widgetWide:
            "0px 12px 33px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A"
    },
    overrides: {
        p: {
            fieldset: {
                toggleable: {
                    textAlign: 'left',
                },
                legend: {
                    textAlign: 'left',
                }
            }
        }

    }
}